'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutGrid } from '@/components/ui/layout-grid';
import type { ProjectImage } from '@/lib/projectsData';
interface ProjectGalleryProps {
  images: ProjectImage[];
  name: string;
}

// Component to display the content when an image is expanded
const ImageContent = t0 => {
  const $ = _c(7);
  const {
    image,
    name
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = <p className="text-xl font-bold text-white md:text-4xl">{name}</p>;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== image.alt) {
    t2 = <p className="my-4 max-w-lg text-base font-normal text-white">{image.alt}</p>;
    $[2] = image.alt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export function ProjectGallery(t0) {
  const $ = _c(8);
  const {
    images,
    name
  } = t0;
  let t1;
  if ($[0] !== images || $[1] !== name) {
    let t2;
    if ($[3] !== images.length || $[4] !== name) {
      t2 = (image, index) => {
        let className = "md:col-span-1";
        if (images.length === 1) {
          className = "md:col-span-3";
        }
        return {
          id: index + 1,
          content: <ImageContent image={image} name={name} />,
          className,
          thumbnail: image.src,
          alt: image.alt
        };
      };
      $[3] = images.length;
      $[4] = name;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = images.map(t2);
    $[0] = images;
    $[1] = name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cards = t1;
  let t2;
  if ($[6] !== cards) {
    t2 = <div className="w-full"><LayoutGrid cards={cards} /></div>;
    $[6] = cards;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}